if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	$('.sym-slides').slick({
        accessibility: false
	});
	
	$('.carousel .wrapper').slick({
		centerMode: true,
		centerPadding: '220px',
		slidesToShow: 1,
		accessibility: true,
		infinite:true,
		responsive: [
			{
				breakpoint: 1500,
				settings: {
					centerPadding: '180px',
				}
			},
			{
				breakpoint: 1200,
				settings: {
					centerPadding: '100px',
				}
			},
			{
				breakpoint: 600,
				settings: {
					centerPadding: '0px',
					fade:true
				}
			}
		]
	});
	$('.gallery-block .gallery').slick({
		centerMode:true,
		accessibility:false,
		slidesToShow:3,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow:2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow:1
				}
			}
		]
	});
	$('.slider-images').slick({
		arrows:false,
		accessibility:false,
		slidesToShow :2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow:1
				}
			}
		]
	});


	$('.gift-slides').slick({
		arrows:true,
		accessibility:false,
		slidesToShow :3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow:2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow:1
				}
			}
		]
	});

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		//outside click
		let alllightbox = document.getElementsByClassName('lightbox');
		let alllightLength = alllightbox.length;
		for(let j = 0; j < alllightLength; j++ ){
			alllightbox[j].addEventListener('click', function(){
				if(this.classList.contains('open')){
					this.classList.remove('open')
				}
			});
		}
	}
	
    
	//email signup animation 
	if(document.getElementById('email-signup_FNAME')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.previousElementSibling.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.previousElementSibling.classList.add('moved');
		})
	}
	
	//light form separate title
	if(document.getElementsByClassName('form-module-wrapper').length > 0){
		let allCMSform = document.getElementsByClassName('form-module-wrapper');
		let allCMSformlength = allCMSform.length;
		for(let i = 0; i < allCMSformlength; i++){
			if(allCMSform[i].classList.contains('light')){
				let formTitle = allCMSform[i].getElementsByTagName('h2')[0];
				let formTitleString = formTitle.innerHTML.split(" ");
				let newTitleEm = '';
				let emTitle = formTitleString[0].split("");
				for(let j = 0; j < emTitle.length; j++){
					newTitleEm = newTitleEm + '<span class="cut">' + emTitle[j] + '</span>';
				}
				let newTitle = '';
				for(let h = 1; h < formTitleString.length; h++){
					newTitle = newTitle + ' ' + formTitleString[h];
				}
				formTitle.innerHTML = '<em>' + newTitleEm + '</em>' + newTitle;
			}
		}
	}

	//CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.previousElementSibling.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.previousElementSibling.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.previousElementSibling.classList.add('moved');
			   })
		   }
	   }
	}
	if(document.getElementsByClassName('field').length > 0){
		 let allfields = document.getElementsByClassName('field');
	 	
		for(let j = 0; j < allfields.length; j++){
			
			if(allfields[j].getElementsByTagName('input').length > 0){
				if(allfields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allfields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
					allfields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
						this.previousElementSibling.classList.add('moved');
					})
				}
			}
			if(allfields[j].getElementsByTagName('select').length > 0){
				allfields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
					this.previousElementSibling.classList.add('moved');
				})
			}
			if(allfields[j].getElementsByTagName('textarea').length > 0){
				allfields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
					this.previousElementSibling.classList.add('moved');
				})
			}
		}
	 }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	// RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});


    

})();

//vanilla js scroll TO animation
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}


//Accordion Feature Quad -- accordion-quad.php --

function displayPanel(elm){
	let panel = elm.nextElementSibling;
	elm.classList.toggle("active-accordion");
	panel.classList.toggle("description-item-expand");
}

let accordions = document.querySelectorAll(".accordion-quad");

accordions.forEach( ( acc ) => {
	acc.addEventListener("click" ,  function(){
		displayPanel(this);
	}); 
});


